export default __webpack_public_path__ + "static/media/freeflix.9023ba26.png";